import React, { useEffect, useState, useRef, useContext } from 'react'
import { Button, Col, message, Row } from 'antd'
import { read, utils } from 'xlsx';
import Utils from '../../../../utils/Utils'
import GenericSelect from '../../../../components/GenericSelect'
import uploadSrc from './uploadSrc'
import { Context } from '../../../../context'

function DescargaTab(props) {
  const [{ auth }] = useContext(Context)

  const [store_chains, setStoreChains] = useState([])
  const [company_id, setCompanyId] = useState(null)
  const [store_chain_id, setStoreChainId] = useState(null)
  const [itemId, setItemId] = useState(null)
  const [json, setJson] = useState(null)
  const [excelName, setExcelName] = useState(null)
  const [sendJsonDisabled, setSendJsonDisabled] = useState(false)
  const inputFileRef = useRef(null); // Referencia al input de archivo

  useEffect(() => {
    if (props.keyTab === '7') {
      onSearchStoreChain()
    }
    // eslint-disable-next-line
  }, [props.keyTab])

  const onSearchStoreChain = val => {
    val !== null ? (val = '') : (val = '')

    const excludeChars = Utils.excludedCharsContent(val)
    Utils.getStoreChainOption(val, excludeChars, 'desc')
      .then(response => {
        setStoreChains(response.data.data)
      })
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar la información de la Cadena')
      })
  }

  const items = [
    { id: 0, name: 'Productos' },
    { id: 1, name: 'Skus' },
    { id: 2, name: 'Niveles de descuento' },
    { id: 3, name: 'Presentaciones' },
    { id: 4, name: 'Presentaciones con niveles de descuento' },
  ]

  const sendJson = async () => {
    let response = null
    setSendJsonDisabled(true)

    switch (itemId) {
      case 0:
        response = await uploadSrc.uploadProducts({ products: json, store_chain_id: store_chain_id })
        break;

      case 1:
        response = await uploadSrc.uploadSkus({ skus: json, store_chain_id: store_chain_id })
        break;

      case 2:
        response = await uploadSrc.uploadDiscounts({ discounts: json, company_id: company_id })
        break;

      case 3:
        response = await uploadSrc.uploadPresentations({ presentations: json, store_chain_id: store_chain_id })
        break;

      case 4:
        response = await uploadSrc.uploadPresentationDiscounts({ presentationDiscounts: json, company_id: company_id })
        break;

      default:
        break;
    }

    if (response.errors) {
      const array = Object.values(response.errors)
    
      for (let index = 0; index < array.length && index < 10; index++) {
        const element = array[index];        
        if(element[0].includes("Undefined index")){
          message.error("No existen elementos para cargar, por favor seleccione un archivo.")
        }else{
          message.error(element)
        }        
      }      
    } else {
      message.success(response.message)      
    }
    setExcelName(""); // Limpiar el nombre del archivo anterior      
    setJson(null);     // Limpiar los datos del archivo anterior
    inputFileRef.current.value = '';
    setSendJsonDisabled(false)
  }

  const readUploadFile = (e) => {
    e.preventDefault();

    if (e.target.files) {     
      setExcelName(e.target.files[0].name)
      const reader = new FileReader();
      reader.onload = async (e) => {
        const data = e.target.result;
        const workbook = read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = utils.sheet_to_json(worksheet);
        
        setJson(json)
      };
      reader.readAsArrayBuffer(e.target.files[0]);
    }
  }

  return (
    <>
      <Row gutter={16} style={{ marginBottom: '1rem' }}>
        <Col xs={9} sm={9} md={9} lg={9}>
          <GenericSelect
            data={store_chains}
            value={(props.edit || store_chain_id !== '') && store_chain_id !== 0 ? store_chain_id : ''}
            handlerChange={value => setStoreChainId(value)}
            placeholder={'Elegir Cadena'}
            disabled={props.edit || !store_chains}
          />
        </Col>
        <Col xs={9} sm={9} md={9} lg={9}>
          <GenericSelect
            data={items}
            value={itemId}
            handlerChange={value => setItemId(value)}
            placeholder={'Elegir datos'}
            disabled={!store_chain_id}
          />
        </Col>
        <Col xs={6} sm={6} md={6} lg={6}>
          {true &&
            <Button onClick={sendJson} disabled={store_chain_id === null || itemId === null || sendJsonDisabled} style={{ width: '100%', height: '100%', color: 'var(--tendero-green)', background: '#ddefe8', border: '#cdcdcd' }} className={'new-deposit'}>
              {sendJsonDisabled ? 'Subiendo' : 'Subir excel'}
            </Button>
          }
        </Col>
      </Row>
      <Row gutter={16} style={{ marginBottom: '1rem' }}>
        <Col xs={9} sm={9} md={9} lg={9} style={{ display: 'grid' }}>
          <input
            ref={inputFileRef}
            id="fichero"
            type="file"
            name={'files'}
            multiple
            accept=".xlsx, .xls"
            onChange={readUploadFile}
          />
          <label for="fichero" style={{ padding: '0.6rem', width: '100%', height: '100%', color: 'var(--tendero-green)', background: '#ddefe8', border: '#cdcdcd' }}>{excelName ? 'Archivo seleccionado' : 'Seleccione archivo'}</label>
          <h5>{excelName ? excelName : ''}</h5>
        </Col>

      </Row>
    </>
  )
}

export default DescargaTab
